import React from "react";
import { UploadOutlined } from "@ant-design/icons";
import type { UploadProps } from "antd";
import { Button, Upload } from "antd";

const UploadAvatar: React.FC<any> = ({ setPreviewImage, setAvatarFile }) => {
  const props: UploadProps = {
    name: "file",
    headers: {
      authorization: "authorization-text",
    },
    beforeUpload: async (file: any) => {
      setPreviewImage(file.originFileObj || file);
      setAvatarFile(file);
      return false;
    },
  };
  return (
    <Upload {...props} accept="image/*" maxCount={1} showUploadList={false}>
      <Button icon={<UploadOutlined />}>Upload</Button>
    </Upload>
  );
};

export default UploadAvatar;